import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import VideMaisonPage from "@/pages/VideMaisonPage";
import BoutiquePage from "@/pages/BoutiquePage";
import RachatCashPage from "@/pages/RachatCashPage";
import HistoirePartenairesPage from "@/pages/HistoirePartenairesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/vide-maison" element={<VideMaisonPage />} />
          <Route path="/boutique" element={<BoutiquePage />} />
          <Route path="/rachat-cash" element={<RachatCashPage />} />
          <Route path="/histoire-partenaires" element={<HistoirePartenairesPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
